import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './_viewMonth.scss'
import {
    setData,
    setDataEnd,
    setDataStart,
    setFasce,
    setKwhAvg,
    setKwhMax,
    setPriceKwhAvgMonth,
    setSpesaAvg,
    setSpesaMax,
} from "../../../features/dataMonthSlice";
import { setPriceKwhAvgWeek } from "../../../features/dataWeekSlice";
import { setPriceKwhAvgYear } from "../../../features/dataYearSlice";
import BarContainer from './_barContainer'
import CircularProgress from '@mui/material/CircularProgress';
import BarIndex from './_barIndex'
import MonthFilter from './_filter'
import CardMonth from './_cardsMonth'
import Fasce from './_fasce'
import ListMonth from './_list'
import { ReactComponent as Euro } from "../../../assets/new-icons/euroIcon.svg";

function ViewMonth() {
    const dispatch = useDispatch()
    const [dateStart, setDateStart] = useState(DateTime.local().startOf('month').toISODate())
    const [dateEnd, setDateEnd] = useState(DateTime.local().endOf('month').toISODate())
    const [dateStartPrevious, setDateStartPrevious] = useState(DateTime.local().startOf('month').plus({months: -1}).toISODate())
    const [dateEndPrevious, setDateEndPrevious] = useState(DateTime.local().startOf('month').plus({months: -1}).toISODate())
    const [lastMonth, setLastMonth] = useState(DateTime.local().endOf('month').toISODate())
    const [loading, setLoading] = useState(true)
    const podCode = useSelector((user) => user.user.info.pod_code)
    const token = useSelector((user) => user.user.info.token_value)
    const userToken = useSelector((user) => user.user.info.user_id)
    const data = useSelector((user) => user.dataMonth.data)
    const maxValueArray = data && data.map((r) => parseFloat(r.kwh_tot))
    const maxEuroArray = data && data.map((r) => parseFloat(r.spesa_giorno))
    const maxValue = maxValueArray && Math.max(...maxValueArray)
    const maxEuro = maxEuroArray && Math.max(...maxEuroArray)
    const maxEuroValue = maxEuroArray && Math.max(...maxEuroArray)
    const maxKwhValue = maxValueArray && Math.max(...maxValueArray)
    const [maxItems, setMaxItems] = useState(6)
    const getSumValue = maxValueArray && maxValueArray.reduce((a, b) => a + b, 0)
    const avarageKwh = maxValueArray && (getSumValue / maxValueArray.length) || 0
    const [switchEuro, setSwitchEuro] = useState(true)
    const [indexBar, setIndexBar] = useState()
    const barGraphRef = useRef(null)

    useEffect(() => {
        init()
    }, [dateStart, dateEnd])
    const setDataMonthSlice = (consumptions, spesaAvgMese, consumptionsAvgCosti, spesaMaxMese, kwhAvgMese, kwhMaxMese, costo_kwh, f1, f2, f3, dateStart, dateEnd) => {
        dispatch(setData(consumptions.reverse()));
        dispatch(setKwhAvg(kwhAvgMese));
        dispatch(setKwhMax(kwhMaxMese));
        dispatch(setSpesaAvg(spesaAvgMese))
        dispatch(setSpesaMax(spesaMaxMese))
        dispatch(setFasce([f1, f2, f3]))
        dispatch(setPriceKwhAvgWeek(consumptionsAvgCosti))
        dispatch(setPriceKwhAvgMonth(consumptionsAvgCosti))
        dispatch(setPriceKwhAvgYear(costo_kwh))
        dispatch(setDataStart(dateStart))
        dispatch(setDataEnd(dateEnd))
    }
    const init = async () => {
        if (!podCode || !token || !userToken) {
            setLoading(true)
            return;
        } else {
            const api = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryMonthNew.php?codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dateStart}&date_end=${dateEnd}`
            const { data: { data } } = await axios.get(api)
            const { consumptions } = data
            if (consumptions.length > 0 && consumptions[consumptions.length - 1].id !== undefined && consumptions[consumptions.length - 1].id !== null) {
                const {
                    consumptions,
                    spesaAvgMese,
                    consumptionsAvgCosti,
                    spesaMaxMese,
                    kwhAvgMese,
                    kwhMaxMese,
                    costo_kwh,
                    total_f1,
                    total_f2,
                    total_f3
                } = data
                const f1 = total_f1.toFixed(2)
                const f2 = total_f2.toFixed(2)
                const f3 = total_f3.toFixed(2)
                const getTotal = consumptions
                .map((r) => parseFloat(r.spesa_giorno))
                .reduce((a, b) => a + b, 0);
                
                if(getTotal !== 0){
                    setDataMonthSlice(consumptions, spesaAvgMese, consumptionsAvgCosti, spesaMaxMese, kwhAvgMese, kwhMaxMese, costo_kwh, f1, f2, f3, dateStart, dateEnd)
                    setLoading(false)
                } 
                
            } else {
                goBackMonth()
            }
        }

    }
    const goBackMonth = () => {
        setLoading(true)
        setMaxItems(6)
        setDateStart(DateTime.fromISO(dateStart).startOf('month').plus({ months: -1 }).toFormat('y-MM-dd'))
        setDateEnd(DateTime.fromISO(dateEnd).plus({ months: -1 }).endOf('month').toFormat('y-MM-dd'))
        setDateStartPrevious(DateTime.fromISO(dateStartPrevious).startOf('month').plus({ months: -1 }).toFormat('y-MM-dd'))
        setDateEndPrevious(DateTime.fromISO(dateEndPrevious).plus({ months: -1 }).endOf('month').toFormat('y-MM-dd'))
    }
    const goForwardMonth = () => {
        setLoading(true)
        setMaxItems(6)
        setDateStart(DateTime.fromISO(dateStart).startOf('month').plus({ months: +1 }).toFormat('y-MM-dd'))
        setDateEnd(DateTime.fromISO(dateEnd).plus({ months: +1 }).endOf('month').toFormat('y-MM-dd'))
        setDateStartPrevious(DateTime.fromISO(dateStartPrevious).startOf('month').plus({ months: +1 }).toFormat('y-MM-dd'))
        setDateEndPrevious(DateTime.fromISO(dateEndPrevious).plus({ months: +1 }).endOf('month').toFormat('y-MM-dd'))
    }
    const goBackYear = () => {
        setLoading(true)
        setMaxItems(6)
        setDateStart(DateTime.fromISO(dateStart).startOf('month').plus({ years: -1 }).toFormat('y-MM-dd'))
        setDateEnd(DateTime.fromISO(dateEnd).plus({ years: -1 }).endOf('month').toFormat('y-MM-dd'))
        setDateStartPrevious(DateTime.fromISO(dateStartPrevious).startOf('month').plus({ years: -1 }).toFormat('y-MM-dd'))
        setDateEndPrevious(DateTime.fromISO(dateEndPrevious).plus({ years: -1 }).endOf('month').toFormat('y-MM-dd'))
    }
    const goForwardYear = () => {
        setLoading(true)
        setMaxItems(6)
        setDateStart(DateTime.fromISO(dateStart).startOf('month').plus({ years: +1 }).toFormat('y-MM-dd'))
        setDateEnd(DateTime.fromISO(dateEnd).plus({ years: +1 }).endOf('month').toFormat('y-MM-dd'))
        setDateStartPrevious(DateTime.fromISO(dateStartPrevious).startOf('month').plus({ years: +1 }).toFormat('y-MM-dd'))
        setDateEndPrevious(DateTime.fromISO(dateEndPrevious).plus({ years: +1 }).endOf('month').toFormat('y-MM-dd'))
    }
    const handleIndexBar = (e) => {
       
        setIndexBar(e)
        const focusDayNum = e;
        const bodyWidth = document.body.clientWidth;
        const barWidth = 170;  // from _CardFullScreen.scss
        const barGap = 25;     // from _CardFullScreen.scss
        const scrollWidth = (barWidth + barGap) * focusDayNum;
        barGraphRef.current.scrollTo(scrollWidth, 0);
    }
    return (
        <div className='month'>
            <div className="month_graph" style={loading ? { alignItems: 'center', justifyContent: 'center' } : null}>
                {loading ? (
                    <div className="loader">
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        <div className="backgroundLine">
                            <div className="line"></div>
                            <div className="line"></div>
                            <div className="line"></div>
                        </div>
                        <BarIndex maxEuroValue={maxEuroValue} switchEuro={switchEuro} maxKwhValue={maxKwhValue}/>
                        <div className="month_graph-wrapper">
                            {data && data.map((d, i) => (
                                d.id && (
                                    <BarContainer key={i} index={i} data={d} switchEuro={switchEuro} maxEuro={maxEuro} maxValue={maxValue} avarageKwh={avarageKwh} handleIndexBar={handleIndexBar} />
                                )
                            ))}
                        </div>
                    </>
                )}
            </div>
            <div className="month-filter_switch">
                <div className="month-filter_switch-right">
                    <MonthFilter goBackYear={() => goBackYear()} goForwardYear={() => goForwardYear()} goForwardMonth={() => goForwardMonth()} goBackMonth={() => goBackMonth()} dateStart={dateStart} dateEnd={dateEnd} lastMonth={lastMonth} />
                </div>
                <div className="month-filter_switch-left">
                    <div className="switch" onClick={() => setSwitchEuro(!switchEuro)}>
                        <div className={`box ${switchEuro ? 'active' : null}`}>
                            <Euro />
                        </div>
                        <div className={`box ${!switchEuro ? 'active' : null}`}>
                            <p>kWh</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="month_cards" ref={barGraphRef}>
                {data && data.map((d, i) => (
                    d.id && (
                        <CardMonth indexBar={indexBar} index={i}  key={i} data={d} />
                    )
                ))}
            </div>
            <Fasce maxEuroArray={maxEuroArray} />
            <ListMonth maxItems={maxItems} setMaxItems={setMaxItems} data={data} goForwardMonth={() => goForwardMonth()} goBackMonth={() => goBackMonth()} dateStart={dateStart} dateEnd={dateEnd} lastMonth={lastMonth} avarageKwh={avarageKwh}/>
            
        </div>
    )
}

export default ViewMonth